import React, { Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute, LayoutSplashScreen } from './_metronic/layout';
import Directories from './pages/Directories/Directories';
import UsersDetail from './pages/UsersManagement/Forms/UsersDetail';
import Track from './pages/Track/Track';
import { useSelector } from 'react-redux';
import UsersManagementPage from './pages/UsersManagement/UsersManagementPage';
import CatalogManagementPage from './pages/CatalogManagement/CatalogManagementPage';
import Start from './pages/Start/Start';
import StartDetail from './pages/Start/StartDetail';
import Search from './pages/Start/Search';
import Structure from './pages/Structure/Structure';
import SessionsPage from './pages/Sessions/SessionsPage';
import CollegiateBody from './pages/Configuration/CollegiateBody/CollegiateBody';
import AdvancedSearch from './pages/AdvancedSearch';
import { authentication } from './pages/Authentication';

export default function BasePage() {
	const user = useSelector((state) => state.auth.user);

	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				{/* INICIO MODULOS QUE TIENEN ACCESO TODOS LOS USUARIOS */}
				<Redirect exact from="/" to={'/inicio'} />
				<ContentRoute path="/inicio" component={Start} />
				<ContentRoute path="/consejos-y-comites" component={StartDetail} />
				<ContentRoute
					path="/busqueda-general/resultados"
					component={AdvancedSearch}
				/>
				{/* <ContentRoute path="/mi-perfil" component={MyProfile} /> */}
				<ContentRoute path="/mi-:perfil/:id" component={UsersDetail} />
				{/* FIN MODULOS QUE TIENEN ACCESO TODOS LOS USUARIOS */}
				{authentication.hasRole(
					[
						'ADMINISTRADOR GENERAL',
						'SISTEMA',
						'RESPONSABLE DE ORGANO COLEGIADO',
						'RESPONSABLE DE NEGOCIO',
					],
					user
				) ? (
					<>
						{/* INICIO TODOS LOS MODULOS FALTANTES */}
						<ContentRoute path="/busqueda-avanzada" component={Search} />
						<ContentRoute path="/configuracion" component={CollegiateBody} />
						<ContentRoute path="/seguimiento" component={Track} />
						<ContentRoute path="/sesiones" component={SessionsPage} />
						<ContentRoute
							path="/administracion-de-usuarios"
							component={UsersManagementPage}
						/>
						<ContentRoute path="/directorio" component={Directories} />
						<ContentRoute path="/estructura" component={Structure} />
						<ContentRoute
							path="/administracion-de-catalogos"
							component={CatalogManagementPage}
						/>
						{/* FIN TODOS LOS MODULOS FALTANTES */}
					</>
				) : (
					''
				)}
				{authentication.hasRole(
					['OPERADOR DE SEGURIDAD', 'RESPONSABLE CASIA'],
					user
				) ? (
					<>
						<ContentRoute
							path="/administracion-de-usuarios"
							component={UsersManagementPage}
						/>
						<ContentRoute path="/seguimiento" component={Track} />
					</>
				) : (
					''
				)}
				{authentication.hasRole(['RESPONSABLE DE SEGUIMIENTO'], user) ? (
					<>
						{/*INICIO SOLO SIN MODULO DE CONFIGURACION */}
						<ContentRoute path="/busqueda-avanzada" component={Search} />
						<ContentRoute
							path="/administracion-de-usuarios"
							component={UsersManagementPage}
						/>
						<ContentRoute
							path="/administracion-de-catalogos"
							component={CatalogManagementPage}
						/>
						<ContentRoute path="/seguimiento" component={Track} />
						<ContentRoute path="/sesiones" component={SessionsPage} />
						<ContentRoute path="/directorio" component={Directories} />
						<ContentRoute path="/estructura" component={Structure} />
						{/*FIN SOLO SIN MODULO DE CONFIGURACION */}
					</>
				) : (
					''
				)}
				{/* FIN MODULOS QUE TIENEN ACCESO TODOS LOS USUARIOS */}
				{authentication.hasRole(['CONSULTA', 'ENLACE'], user) ? (
					<>
						<ContentRoute path="/seguimiento" component={Track} />
						<ContentRoute path="/sesiones" component={SessionsPage} />
						<ContentRoute path="/directorio" component={Directories} />
						<ContentRoute path="/estructura" component={Structure} />
					</>
				) : (
					''
				)}
			</Switch>
		</Suspense>
	);
}
